import { useSelector } from "react-redux";
import Banner from "../../components/Banner/Banner";
import Choose from "../../components/Choose/Choose";
import Discover from "../../components/Discover/Discover";
import Journey from "../../components/Journey/Journey";
import Main from "../../components/Main/_index";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
import translations from "../../language.json";

const About = () => {
  const selectedLanguages = useSelector(selectedLanguage);

  return (
    <>
      <Main
        backimg="/img/aboutback.jpg"
        title={translations[selectedLanguages].aboutMain.title}
        context={translations[selectedLanguages].aboutMain.context}
      />
      <Discover />
      <Choose />
      <Journey />
      <Banner />
    </>
  );
};

export default About;
